import { numberFormat } from "utils/nuberFormat";
import styled from "@emotion/styled";
import { Col, Input, Row, Typography } from "antd";
import { Dispatch, FC, SetStateAction, useEffect, useState } from "react";

interface MainCreateTotalPricePaymentProps {
  // privilegePrice?: number;
  totalPrice: number;
  servicePrice: number;
  disCount: number;
  setDisCount: Dispatch<SetStateAction<number>>;
  order_payment_type?: string;
}

const MainCreateTotalPricePayment: FC<MainCreateTotalPricePaymentProps> = ({
  // privilegePrice,
  totalPrice,
  servicePrice,
  disCount,
  setDisCount,
  order_payment_type
}) => {

   const [isKsher, setIsKsher] = useState<boolean>(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const intValue = value.replace(/[^0-9]/g, '');
    const discountValue = intValue !== '' ? parseInt(intValue) : 0;

    if (discountValue > Number(totalPrice + servicePrice)) {
      // If discount exceeds total price, set discount to total price or handle as needed
      setDisCount(Number(totalPrice + servicePrice));
    } else {
      setDisCount(discountValue);
    }
  };

  useEffect(() => {
      //check is promptpay
      console.log("order_payment_type", order_payment_type);
      if (order_payment_type === "promptpay" || order_payment_type === "credit") {
        setIsKsher(true);
      } else {
        setIsKsher(false);
      }
    }, [order_payment_type]);

  return (
    <>
      <FormWrapper>
        <FormItemWrapper>
          <Row style={{ backgroundColor: "#FFFFFF" }}>
            <Col span={24} style={{ padding: 5, display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
              <Typography.Title level={5} style={{ margin: 0 }}>
                ส่วนลด
              </Typography.Title>
              <Input 
                type="number"
                size="small" 
                styles={{}}
                placeholder="กำหนดจำนวนเงินใส่ส่วนลด" 
                style={{ width: "200px", marginLeft: 10, textAlign: "right" }} 
                value={disCount}
                onChange={handleInputChange}
                disabled={isKsher}
              />
              <Typography.Title level={5} style={{ margin: 0 }}>
                บาท
              </Typography.Title>
            </Col>
          </Row>
          <Row style={{ backgroundColor: "#FFFFFF" }}>
            <Col span={24}>
              <Typography.Title level={5} style={{ padding: 5, display: "flex", justifyContent: "flex-end" }}>
                ราคาที่ต้องชำระ: {numberFormat((servicePrice + totalPrice) - disCount)} บาท
              </Typography.Title>
            </Col>
          </Row>
        </FormItemWrapper>
      </FormWrapper>
    </>
  );
};

export default MainCreateTotalPricePayment;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffffff;
`;

const FormItemWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 10px 0px 10px 0px;
  border-radius: 10px;
`;
